import styled from "styled-components";

export function darkenColor(hex: string, percent: number): string {
  const cleanedHex = hex.replace(/^#/, "");

  const num = Number.parseInt(cleanedHex, 16);
  const r = (num >> 16) & 0xff;
  const g = (num >> 8) & 0xff;
  const b = num & 0xff;

  const newR = Math.max(0, r - (r * percent) / 100);
  const newG = Math.max(0, g - (g * percent) / 100);
  const newB = Math.max(0, b - (b * percent) / 100);

  return (
    "#" +
    (
      (1 << 24) +
      (Math.round(newR) << 16) +
      (Math.round(newG) << 8) +
      Math.round(newB)
    )
      .toString(16)
      .slice(1)
  );
}

export const StyledPercentageContent = styled.div<{
  $selectedChip: boolean;
  $color?: string;
}>`
  padding: 0px 15px;
`;
